import { CONSTANTS } from 'configs/constants'
import { rest } from 'msw'
import { build, fake, sequence } from '@jackfranklin/test-data-bot'

const timeZone = build({
  fields: {
    id: fake((f) => `America/${f.address.city()}`),
    name: fake((f) => f.address.city()),
    offset: sequence((x) => `0${x}:00`),
  },
})

const timeZonesBuilder = build({
  fields: [],
  postBuild: () => {
    return [
      {
        id: 'America/Lima',
        name: 'Lima',
        offset: '-05:00',
      },
      ...Array(9)
        .fill(undefined)
        .map((_) => timeZone()),
    ]
  },
})

const timeZonesHandler = rest.get(
  `${CONSTANTS.THE_ADMIN_API_URL}/v1/products/timezones`,
  (_, res, ctx) => {
    return res(ctx.json(timeZonesBuilder()))
  }
)

export default timeZonesHandler
